import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { Chip } from "@mui/material";
import { useState } from "react";
import useColors from "../../api/hooks/useColors";
import LoadingIcon from "../LoadingIcon";

export default function LoadingDeletableChip({
  label,
  onDelete,
  size = "medium",
  iconStyle = {},
  ...props
}) {
  const colors = useColors();
  const [isLoading, setIsLoading] = useState(false);

  let fontSize, height, borderRadius;

  switch (size) {
    case "large":
      fontSize = "14px";
      height = "40px";
      borderRadius = "14px";
      break;
    case "medium":
      fontSize = "12px";
      height = "32px";
      borderRadius = "8px";
      break;
    case "small":
      fontSize = "12px";
      height = "24px";
      borderRadius = "8px";
      break;
    default:
      fontSize = "12px";
      height = "32px";
      borderRadius = "8px";
  }

  const handleOnDelete = async () => {
    setIsLoading(true);
    try {
      await onDelete();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Chip
      label={label}
      variant="outlined"
      onDelete={handleOnDelete}
      deleteIcon={
        isLoading ? (
          <LoadingIcon
            size={size === "large" ? 18 : size === "medium" ? 16 : 14}
          />
        ) : (
          <CancelRoundedIcon
            style={{
              fontSize:
                size === "large" ? "18px" : size === "medium" ? "16px" : "14px",
              ...iconStyle,
            }}
          />
        )
      }
      disabled={isLoading}
      sx={{
        height: height,
        borderColor: colors.grey_20percent,
        borderRadius: borderRadius,
        color: colors.text_primary,
        fontSize: fontSize,
        fontWeight: 400,
        lineHeight: "20px",
        ...props.sx,
      }}
    />
  );
}
